import React from "react";
import { Link } from "react-router-dom";
import { useSiteConfig } from "@/lib/siteConfig";

export default function Footer() {
  const { config = {} } = useSiteConfig();
  const featuredCategories = Array.isArray(config.home_categories)
    ? config.home_categories.filter((c) => c && (c.name || c.category))
    : [];

  return (
    <footer className="bg-black text-white mt-24 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Brand & Dati Societari */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="font-display font-black text-4xl">
              <span className="text-white">B</span>
              <span className="text-[var(--bs-red)]">S</span>
            </span>
            <div>
              <div className="font-display font-bold text-lg">Buti Stock</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-400">
                Vendita stock e fallimenti
              </div>
            </div>
          </div>
          <p className="text-xs text-zinc-400 leading-relaxed mb-4">
            Acquisto e vendita stock aziendali, giacenze di magazzino, fine serie e fallimenti. Formula visto e piaciuto, sconti reali e qualità verificata.
          </p>
          <div className="text-xs text-zinc-400 leading-relaxed font-mono-bs space-y-0.5">
            <p className="font-bold text-zinc-200">ALBA JON S.R.L.S.</p>
            <p>P.IVA: 02390170500</p>
            <p>Via Spagna 19, 56032 Buti (PI)</p>
          </div>
        </div>

        {/* Reparti & Catalogo */}
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4 text-zinc-200">Negozio</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/shop" className="hover:text-[var(--bs-red)] transition-colors">Tutti i prodotti</Link></li>
            {featuredCategories.map((item) => (
              <li key={item.name || item.category}>
                <Link
                  to={`/shop?category=${encodeURIComponent(item.name || item.category)}`}
                  className="hover:text-[var(--bs-red)] transition-colors"
                >
                  {item.name || item.category}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Informazioni Legali Obbligatorie */}
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4 text-zinc-200">Informazioni Legali</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>
              <Link to="/condizioni-vendita" className="hover:text-[var(--bs-red)] transition-colors">
                Informazioni sul servizio
              </Link>
            </li>
            <li>
              <Link to="/diritto-recesso" className="hover:text-[var(--bs-red)] transition-colors">
                Disponibilità e ritiro
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="hover:text-[var(--bs-red)] transition-colors">
                Informativa Privacy (GDPR)
              </Link>
            </li>
            <li>
              <Link to="/cookie-policy" className="hover:text-[var(--bs-red)] transition-colors">
                Cookie Policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Contatti & Assistenza */}
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4 text-zinc-200">Contatti & Assistenza</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>
              <a href="mailto:info@butistock.it" className="hover:text-[var(--bs-red)] transition-colors">
                info@butistock.it
              </a>
            </li>
            <li><Link to="/dove-siamo" className="hover:text-[var(--bs-red)] transition-colors">Dove siamo & contatti</Link></li>
            <li>Via Spagna 19, 56032 Buti (PI)</li>
            <li>Supporto Clienti: Lun - Ven</li>
            <li className="pt-2">
              <a
                href="https://www.facebook.com/share/1BrXjuBS93/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 hover:text-[var(--bs-red)] transition-colors"
              >
                Seguici su Facebook ↗
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-900 py-6 text-center text-xs text-zinc-500 font-mono-bs tracking-widest px-4">
        © {new Date().getFullYear()} BUTI STOCK — ALBA JON S.R.L.S. (P.IVA 02390170500) — TUTTI I DIRITTI RISERVATI
      </div>
    </footer>
  );
}